/**
 * @flow
 *
 * The purpose of this module is to deprecate github.com/uniiverse/embed
 *
 * Currently, an 'embed' widget is deployed on a host's page by embedding our
 * embed bootstrapper script as well an iframe tag like the following
 *
 * <!-- Listings widget -->
 * <iframe
 *  id="unii-embed-page"
 *  src="https://www.universe.com/embed/#/users/mxnationals-ca-ZMLBV"></iframe>
 *
 * <!-- Ticket widget -->
 * <iframe
 *  id="unii-embed-page"
 *  src="https://universe.com/embed/listings/techcrunch-sessions-robotics-tickets-056ZT8"
 *  width="100%"
 *  style="height: 450px;"></iframe>
 *
 * The idea is to enable Juno's bootstrapper to extract information from such
 * iframe tag and use it to build a new iframe that contains the new widget
 */

import qs from 'querystring';
import type Orchestrator from '../orchestrator';
import type { UniverseEmbedWidget as EmbedWidget } from '../widget';

type WidgetConfig = {
  widgetType: string;
  targetType: 'listing' | 'user';
  targetId: string;
};


export function replaceEmbed(orc: Orchestrator, oldIframe: any) {
  if (!oldIframe.src) {
    return;
  }

  const embedPattern = /\/embed\/(\#\/)?(listings|users)\/([\w|\-]+)\/?(\?([^/>#]+))?/;
  const [_a, _b, target, rawSlug, state] = oldIframe.src.match(embedPattern);

  if (!target || !rawSlug) {
    return;
  }

  const [_c, targetSlug] = rawSlug.match(/\-?([a-zA-Z0-9]+)$/);

  if (!targetSlug) {
    return;
  }

  let targetType: string;
  let widgetType: string;

  switch (target) {
    case 'listings': {
      widgetType = 'universe-ticket';
      targetType = 'listing';
      break;
    }

    case 'users': {
      widgetType = 'universe-listings';
      targetType = 'user';
      break;
    }

    default: {
      return;
    }
  }

  const container: HTMLElement = oldIframe.parentElement || oldIframe;
  let initState: WidgetConfig;

  try {
    initState = { ...qs.parse(state), targetType, targetId: targetSlug, widgetType };
  }
  catch (e) {
    initState = { targetType, targetId: targetSlug, widgetType };
  }

  const widget: ?EmbedWidget = orc.register(
    container,
    widgetType,
    initState
  );

  if (widget) {
    widget.mount(oldIframe);
    container.removeChild(oldIframe);
  }
}

export default function replaceEmbeds(orc: Orchestrator) {
  if (document.readyState === 'loading') {
    // replace when DOM is fully parsed
    document.addEventListener('DOMContentLoaded', () => {
      replaceEmbeds(orc);
    }, false);
    return;
  }

  const oldWidgets: NodeList<HTMLElement> = document.querySelectorAll('iframe#unii-embed-page');

  for (let i = 0; i < oldWidgets.length; i ++) {
    replaceEmbed(orc, oldWidgets[i]);
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/plugins/replaceEmbed.js